function cookieAccept(name) {
    localStorage.setItem(name, 'yesbox');
    removeElement(name + '_info');
}
function removeElement(elementId) {
    var element = document.getElementById(elementId);
    element.parentNode.removeChild(element);
}
if (localStorage.getItem('cookies') == 'yesbox') {
    removeElement('cookies_info');
}